import { classNames } from "../../../utils/common";
import styles from "./NavbarLogoWrapper.module.css";

type NavbarLogoProps = {
  children: React.ReactNode;
};

type NavbarItemInternalProps = {
  expanded: boolean;
  isActive: boolean;
};

export const NavbarLogoWrapper = (props: NavbarLogoProps) => {
  const { children, ...internalProps } = props;
  // Typecasting here to use the internal props because it is added only in Navbar component
  const { expanded: isExpanded } = internalProps as NavbarItemInternalProps;

  return (
    <li
      className={classNames({
        [styles.catalystNavbarLogo]: true,
        [styles.catalystNavbarLogoCollapsed]: !isExpanded
      })}
      aria-label="brand logo"
    >
      {children}
    </li>
  );
};
